import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import ProductCenter from '@/view/product/ProductCenter'
import IndustryNews from '@/view/news/IndustryNews'
import aboutMe from '@/view/aboutMe/aboutMe'
import sharingList from '@/view/TechnologySharing/sharingList'
import sharingDetail from '@/view/TechnologySharing/detail'
import newsDetail from '@/view/news/detail'
import productDetail from '@/view/product/detail'
import aboutMeDetail from '@/view/aboutMe/detail'

const Layout = () => import('@/components/layout')

Vue.use(Router)
const language = localStorage.getItem('language')
export default new Router({
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      meta: {
        title: language === 'E' ? 'HOME' : '首页',
        nav: true // 导航菜单 渲染作用
      },
      path: '/',
      component: Layout,
      children: [
        {
          meta: {
            parent: language === 'E' ? 'HOME' : '首页',
            title: language === 'E' ? 'HOME' : '首页'
          },
          path: '/',
          name: 'index',
          component: index
        }
      ]
    },
    {
      meta: {
        title: language === 'E' ? 'Product Center' : '产品中心',
        nav: true // 导航菜单 渲染作用
      },
      path: '/ProductCenter',
      component: Layout,
      children: [
        {
          meta: {
            parent: language === 'E' ? 'Product Center' : '产品中心',
            title: language === 'E' ? 'Product Center' : '产品中心'
          },
          path: '/ProductCenter',
          name: 'ProductCenter',
          component: ProductCenter
        },
        {
          meta: {
            parent: language === 'E' ? 'Product Center' : '产品中心',
            title: language === 'E' ? 'Product Center' : '产品详情'
          },
          path: '/productDetail/:id/:index',
          name: 'productDetail',
          component: productDetail
        }
      ]
    },
    {
      meta: {
        title: language === 'E' ? 'Core Values' : '案例展示',
        nav: true // 导航菜单 渲染作用
      },
      path: '/sharingList',
      component: Layout,
      children: [
        {
          meta: {
            parent: language === 'E' ? 'Core Values' : '案例展示',
            title: language === 'E' ? 'Core Values' : '案例展示'
          },
          path: '/sharingList',
          name: 'sharingList',
          component: sharingList
        },
        {
          meta: {
            parent: language === 'E' ? 'Core Values' : '案例展示',
            title: language === 'E' ? 'Core Values' : '案例展示'
          },
          path: '/sharingDetail/:id',
          name: 'sharingDetail',
          component: sharingDetail
        }
      ]
    },
    {
      meta: {
        title: language === 'E' ? 'Industry News' : '行业新闻',
        nav: true // 导航菜单 渲染作用
      },
      path: '/IndustryNews',
      component: Layout,
      children: [
        {
          meta: {
            parent: language === 'E' ? 'Industry News' : '行业新闻',
            title: language === 'E' ? 'Industry News' : '行业新闻'
          },
          path: '/IndustryNews',
          name: 'IndustryNews',
          component: IndustryNews
        },
        {
          meta: {
            parent: language === 'E' ? 'Industry News' : '行业新闻',
            title: language === 'E' ? 'Industry News' : '行业新闻详情'
          },
          path: '/newsDetail/:id/:type?',
          name: 'newsDetail',
          component: newsDetail
        }

      ]
    },
    {
      meta: {
        title: language === 'E' ? 'About Us' : '关于我们',
        nav: true // 导航菜单 渲染作用
      },
      path: '/aboutMe',
      component: Layout,
      children: [
        {
          meta: {
            parent: language === 'E' ? 'About Us' : '关于我们',
            title: language === 'E' ? 'About Us' : '关于我们'
          },
          path: '/aboutMe',
          name: 'aboutMe',
          component: aboutMe
        },
        {
          meta: {
            parent: language === 'E' ? 'Company News' : '公司新闻',
            title: language === 'E' ? 'Company News' : '公司新闻详情'
          },
          path: '/aboutMeDetail/:id',
          name: 'aboutMeDetail',
          component: aboutMeDetail
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js